// extracted by mini-css-extract-plugin
export var ButtonContainer = "manuals-module--ButtonContainer--4ec39";
export var InputContainer = "manuals-module--InputContainer--4860a";
export var ManualContainer = "manuals-module--ManualContainer--eda60";
export var NoResultsMessage = "manuals-module--NoResultsMessage--4fecb";
export var Op = "manuals-module--Op--49f2c";
export var ResultadosContainer = "manuals-module--ResultadosContainer--fa00c";
export var ResultsItem = "manuals-module--ResultsItem--21c88";
export var SearchBtnContainer = "manuals-module--SearchBtnContainer--dc26d";
export var SectionContainer = "manuals-module--SectionContainer--eb807";
export var SelectContainer = "manuals-module--SelectContainer--ab50d";
export var SimpleInput = "manuals-module--SimpleInput--6be48";
export var SimpleSelect = "manuals-module--SimpleSelect--d8f64";
export var TextContainer = "manuals-module--TextContainer--2f816";
export var TitleContainer = "manuals-module--TitleContainer--fe83b";
export var intro = "manuals-module--intro--f1d8e";
export var mainContainer = "manuals-module--mainContainer--4e80d";